import React, { useState, useEffect } from 'react';
import css from './PasswordGate.module.css';

/**
 * PasswordGate - A simple password protection layer for the marketplace
 *
 * Set the password in environment variable: REACT_APP_SITE_PASSWORD
 * If not set, the site is open to everyone.
 */
const PasswordGate = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  // The site password from environment variable
  const sitePassword = process.env.REACT_APP_SITE_PASSWORD;

  useEffect(() => {
    // Check if already authenticated (stored in sessionStorage)
    const storedAuth = sessionStorage.getItem('seva_site_auth');
    if (storedAuth === 'true') {
      setIsAuthenticated(true);
    }
  }, []);

  // If no password is set, allow access
  if (!sitePassword) {
    return children;
  }

  // If authenticated, show the site
  if (isAuthenticated) {
    return children;
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    if (password === sitePassword) {
      setIsAuthenticated(true);
      sessionStorage.setItem('seva_site_auth', 'true');
      setError('');
    } else {
      setError('Incorrect password. Please try again.');
      setPassword('');
    }
  };

  return (
    <div className={css.container}>
      <div className={css.card}>
        <div className={css.logo}>
          <h1 className={css.title}>Seva Sethu</h1>
          <p className={css.subtitle}>Vaishnava Marketplace</p>
        </div>

        <div className={css.notice}>
          <p>This marketplace is currently in private beta.</p>
          <p>Please enter the access password to continue.</p>
        </div>

        <form onSubmit={handleSubmit} className={css.form}>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Enter access password"
            className={css.input}
            autoFocus
          />
          {error && <p className={css.error}>{error}</p>}
          <button type="submit" className={css.button}>
            Enter Marketplace
          </button>
        </form>

        <p className={css.contact}>
          Need access? Contact the administrator.
        </p>
      </div>
    </div>
  );
};

export default PasswordGate;
